export default class Appropriate {
  constructor (options) {
    // OPTIONS:
    // formSelector:     form selector or form's parent selector
    // onCandidateCheck: callback, what should happen when candidate was chacked. 2 Arguments - checkedCount(number) and allChecked(boolean)
    const $formSelector = $(options.formSelector)
    $(document).on('customizable_table_ready', (e, table) => {
      $(document).on('change', 'input.selectable-candidate', () => {
        if (_.isFunction(options.onCandidateCheck)) { options.onCandidateCheck(this.checkedCount(), this.allChecked()) }
      }).trigger('change')

      $('[type="submit"]', $formSelector).on('click', (e) => {
        const $form = $(e.target.form)
        const ids = $('tr.selectable-item.selected-item').map((i, el) => $(el).attr('id')).get().join(',')
        $form.find('input[name="selected_ids"]').val(ids)
      })
    })
  }

  checkedCount () {
    return $('.selectable-candidate:checked').length
  }

  allChecked () {
    return $('.selectable-candidate').length === this.checkedCount()
  }
}
